import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../../utils/test-utils/unidriver';

export const actionLinkDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /** Returns link label */
    getLabel: () => base.text(),
  };
};

export type ActionLinkDriver = ReturnType<typeof actionLinkDriverFactory>;
